import { toast } from 'react-toastify';

import { createDefaultHeaders, getJSONOrThrow } from '@/api';
import { getSession, urlWithAdminQuery } from '@/auth';
import { log } from '@/util';

import type { AlertHistoryResponse } from './types';

export const getAlertHistory = async (
  structureId: string,
  page: number = 1,
  pageSize: number = 25,
  unitId?: string,
): Promise<AlertHistoryResponse | null> => {
  try {
    const session = await getSession();
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(pageSize),
    });
    if (unitId) {
      params.set('unit_id', unitId);
    }

    const resp = await fetch(
      urlWithAdminQuery(
        `/structure/${structureId}/alert-history?${params.toString()}`,
        session.adminEmail,
      ),
      {
        method: 'GET',
        headers: createDefaultHeaders({
          authToken: session.idToken.toString(),
        }),
      },
    );

    return await getJSONOrThrow(resp);
  } catch (err) {
    log.error(err);
    toast.error('Failed to load alert history', { closeButton: true });
    return null;
  }
};
